export { default } from './es/icons/SuccessTwoTone';